import { Link } from 'react-router-dom';
import { TMS_CONNECTION_READY } from 'lib/tmsConnection';

export default function TmsConnectionBoundary({ children }) {
  if (TMS_CONNECTION_READY) return children;
  return (
    <main className="min-h-screen bg-canvas px-6 pb-24 pt-40 text-ink">
      <section className="mx-auto max-w-2xl border border-gold/25 bg-surface p-8 sm:p-12">
        <p className="mb-4 text-sm uppercase tracking-widest text-accent-ink">Customer services</p>
        <h1 className="mb-6 font-display text-3xl sm:text-4xl">TMS connection in progress</h1>
        <p role="status" className="mb-5 text-base leading-7 text-copy/75">
          Online checkout, account access, agreements, and protected downloads are temporarily unavailable.
          No payment or request is submitted from this page.
        </p>
        <p className="mb-8 text-base leading-7 text-copy/60">
          Existing purchases are not cancelled. Access will be available after the TMS connection
          and purchase records have been verified.
        </p>
        <Link to="/" className="inline-block border border-gold/60 px-5 py-3 text-base text-accent-ink">
          Return to the website
        </Link>
      </section>
    </main>
  );
}
